if (!customElements.get('editorial-skin-accordion')) {
  customElements.define(
    'editorial-skin-accordion',
    class EditorialSkinAccordion extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.items = Array.from(this.querySelectorAll('details'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.items.forEach((item) => {
          const summary = item.querySelector(':scope > summary');
          if (!summary) return;

          summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
          summary.addEventListener('click', (event) => this.handleClick(event, item, summary));
        });
      }

      handleClick(event, item, summary) {
        event.preventDefault();

        if (item.dataset.accordionAnimating === 'true') return;

        const shouldOpen = !item.open;

        if (shouldOpen) {
          this.items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.open) {
              const otherSummary = otherItem.querySelector(':scope > summary');
              this.animateItem(otherItem, otherSummary, false);
            }
          });
        }

        this.animateItem(item, summary, shouldOpen);
      }

      animateItem(item, summary, shouldOpen) {
        if (!summary || item.dataset.accordionAnimating === 'true') return;

        if (this.reduceMotion.matches) {
          item.open = shouldOpen;
          summary.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          return;
        }

        const startHeight = item.getBoundingClientRect().height;
        let endHeight;

        if (shouldOpen) {
          item.open = true;
          endHeight = item.scrollHeight;
        } else {
          item.open = false;
          endHeight = item.getBoundingClientRect().height;
          item.open = true;
        }

        item.dataset.accordionAnimating = 'true';
        item.style.height = `${startHeight}px`;
        item.style.overflow = 'hidden';
        summary.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

        const content = summary.nextElementSibling;
        const contentAnimation = content
          ? content.animate(
              shouldOpen ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 1 }, { opacity: 0 }],
              {
                duration: shouldOpen ? 220 : 120,
                easing: 'ease-out',
                fill: 'both',
              }
            )
          : null;

        const animation = item.animate(
          [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
          {
            duration: 320,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'none',
          }
        );

        animation.finished
          .then(() => {
            item.open = shouldOpen;
          })
          .catch(() => {})
          .finally(() => {
            animation.cancel();
            contentAnimation?.cancel();
            item.style.removeProperty('height');
            item.style.removeProperty('overflow');
            delete item.dataset.accordionAnimating;
          });
      }
    }
  );
}
